import { EvaluationFormsStateTypes, EvaluationFormsActionTypes } from "./EvaluationForms.type";
import { resetApiCallState } from "../../Utils";

const INITIAL_STATE: EvaluationFormsStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EvaluationFormsReducer = (
  state: EvaluationFormsStateTypes = INITIAL_STATE,
  action: any
): EvaluationFormsStateTypes => {
  switch (action.type) {
    case EvaluationFormsActionTypes.FETCH_ALL_EVALUATION_FORMS:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EvaluationFormsActionTypes.FETCH_ALL_EVALUATION_FORMS_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EvaluationFormsActionTypes.FETCH_ALL_EVALUATION_FORMS_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EvaluationFormsActionTypes.FETCH_ALL_EVALUATION_FORMS_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EvaluationFormsActionTypes.FETCH_ONE_EVALUATION_FORMS:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EvaluationFormsActionTypes.FETCH_ONE_EVALUATION_FORMS_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EvaluationFormsActionTypes.FETCH_ONE_EVALUATION_FORMS_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EvaluationFormsActionTypes.FETCH_ONE_EVALUATION_FORMS_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EvaluationFormsReducer;
